import * as actionTypes from "../../actionLabels/addNotification/addNotification";

const initialState = {
  createNotification: null,
  allNotifications: [],
  hasMoreData: true, // Initially assume there is more data
  beforeLoginMarquee : [],
  notificationData: [],
  updatedNotification: [],
  searchResults: [],
  createEditNotificationApiStatus: false,
  createdNotificationDisable: false,
  error: null,
  notificationLoader: false,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        createNotification: true,
        error: null,
      };

    case actionTypes.CREATE_NOTIFICATION_FAIL:
      return {
        ...state,
        createNotification: null,
        error: action.payload,
      };

    case actionTypes.CREATE_EDIT_NOTIFICATION_API_STATUS:
      return {
        ...state,
        createEditNotificationApiStatus: action.payload.data,
      };

    case actionTypes.CREATE_NOTIFICATION_DISABLE:
      return {
        ...state,
        createdNotificationDisable: action.payload.data,
      };

    case actionTypes.NOTIFICATION_LOADER:
      return {
        ...state,
        notificationLoader: action.payload.data,
      };

    // get all notification
    case actionTypes.GET_ALL_NOTIFICATIONS_SUCCESS:
      console.log("GET_ALL_NOTIFICATIONS action.payload:", action.payload);
      return {
        ...state,
        allNotifications: action.payload,
        error: null,
      };

    case actionTypes.GET_ALL_NOTIFICATIONS_FAIL:
      return {
        ...state,
        allNotifications: [],
        error: action.payload,
      };

    // get notification by id 
    case actionTypes.GET_NOTIFICATIONS_BY_ID_SUCCESS:
      return {
        ...state,
        notificationData: action.payload,
        error: null,
      };

    case actionTypes.GET_NOTIFICATIONS_BY_ID_FAIL:
      return {
        ...state,
        notificationData: [],
        error: action.payload,
      };

    // Update Notification
    case actionTypes.UPDATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        updatedNotification: action.payload,
        error: null,
      };

    case actionTypes.UPDATE_NOTIFICATION_FAIL:
      return {
        ...state,
        updatedNotification: [],
        error: action.payload,
      };

    // Search notification
    case actionTypes.SEARCH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        searchResults: action.payload,
        error: null,
      };

    case actionTypes.SEARCH_NOTIFICATION_FAIL:
      return {
        ...state,
        searchResults: [],
        error: action.payload,
      };

    // Get Before Login Marquee
    case actionTypes.BEFORE_LOGIN_MARQUEE_SUCCESS:
      return {
        ...state,
        beforeLoginMarquee: action.payload,
        error: null,
      };

    case actionTypes.BEFORE_LOGIN_MARQUEE_FAIL:
      return {
        ...state,
        beforeLoginMarquee: [],
        error: action.payload,
      };
      
    default:
      return state;
  }
}

export default notificationReducer